// Vendor
import * as React from 'react';
import { BarItemProps } from '@nivo/bar';
import { SPOT_GREY_7 } from '@thredup/styleguide/src/variables/colors';

const Bar: React.FC<BarItemProps> = (props) => {
  const { data, color, height, width, x, y } = props;
  const { id } = data;

  return (
    <g transform={`translate(${x}, ${y})`}>
      <rect
        fill={color}
        height={height}
        stroke="white"
        strokeWidth="0"
        width={width}
      />
      <text
        className="text-sm"
        dominantBaseline="central"
        fill={SPOT_GREY_7}
        textAnchor="middle"
        x={25}
        y={height / 2}
      >
        {id}
      </text>
    </g>
  );
};

export { Bar };
